<template>
  <section class="bg-[#010d1a] min-h-screen text-white">
    <div class="max-w-6xl mx-auto px-4 py-10">

      <!-- Loading -->
      <div v-if="pending" class="flex items-center justify-center py-32 text-cyan-400">
        <svg class="animate-spin w-7 h-7 mr-3" fill="none" viewBox="0 0 24 24" aria-hidden="true">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        {{ t.loading }}
      </div>

      <!-- Produto -->
      <div v-else-if="safeProduct?.id">

        <!-- ÔöÇÔöÇ HERO ÔöÇÔöÇ -->
        <div class="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">

          <!-- Imagem -->
          <div class="relative rounded-2xl overflow-hidden bg-[#021326] border border-cyan-500/20 flex items-center justify-center p-6 min-h-[320px] lg:min-h-[480px]">
            <img
              :src="safeImage"
              :alt="safeProduct.imageAlt || safeProduct.name"
              :title="safeProduct.imageTitle || undefined"
              fetchpriority="high"
              loading="eager"
              decoding="async"
              class="w-full max-h-[440px] object-contain brightness-110 contrast-110 saturate-110"
              referrerpolicy="no-referrer"
              @error="onImageError"
            />
            <figcaption v-if="safeProduct.imageCaption" class="sr-only">{{ safeProduct.imageCaption }}</figcaption>
            <div v-if="discountPercent" class="absolute top-3 right-3">
              <span class="inline-flex items-center rounded-full bg-red-600 px-3 py-1 text-sm font-black text-white tracking-wider">
                {{ discountPercent }}% OFF
              </span>
            </div>
          </div>

          <!-- Coluna compra -->
          <div class="flex flex-col gap-5">

            <!-- Urgência topo -->
            <div class="inline-flex items-center gap-2 bg-orange-500/15 border border-orange-500/40 rounded-full px-4 py-1.5 text-sm font-bold text-orange-400 w-fit">
              {{ t.urgencyBadge }}
            </div>

            <!-- Título -->
            <h1 class="text-2xl md:text-3xl font-extrabold text-white leading-tight">
              {{ safeProduct?.name || 'Produto digital' }}
            </h1>

            <!-- Preço -->
            <div class="flex flex-col gap-1">
              <div v-if="formattedOldPrice" class="flex items-center gap-3">
                <span class="text-slate-500 line-through text-lg">{{ formattedOldPrice }}</span>
                <span v-if="discountPercent" class="text-xs font-black text-red-400 bg-red-400/10 rounded-full px-2 py-0.5">-{{ discountPercent }}%</span>
              </div>
              <div class="text-5xl font-black text-[#00e676] drop-shadow-[0_0_20px_rgba(0,230,118,0.5)] leading-none">
                {{ formattedPrice }}
              </div>
              <div v-if="installments12" class="text-sm text-slate-400 mt-1">
                {{ t.installmentsPrefix }} {{ installments12 }} sem juros
              </div>
              <div v-if="isBrl && formattedPixPrice" class="text-sm font-semibold text-cyan-400 mt-0.5">
                🛒░ PIX à vista: <span class="text-white">{{ formattedPixPrice }}</span>
              </div>
            </div>

            <!-- CTA principal -->
            <button
              type="button"
              class="w-full bg-[#00e676] hover:bg-[#00ff87] active:scale-[0.98] text-[#010d1a] text-lg font-black uppercase tracking-widest py-4 rounded-xl transition-all duration-200 shadow-[0_0_30px_rgba(0,230,118,0.35)]"
              @click="buyNow"
            >
              {{ t.buyNowBtn }}
            </button>

            <!-- Adicionar ao carrinho -->
            <button
              type="button"
              class="w-full bg-white/10 hover:bg-white/20 active:scale-[0.98] text-white text-lg font-bold uppercase tracking-widest py-4 rounded-xl transition-all duration-200 border border-white/20"
              @click="addToCartOnly"
            >
              🛒 {{ t.addToCartBtn || 'Add to Cart' }}
            </button>

            <!-- Benefícios -->
            <div class="grid grid-cols-2 gap-3">
              <div class="flex items-center gap-2 bg-white/5 rounded-xl px-3 py-2.5 text-sm text-slate-300 font-medium">
                <span class="text-[#00e676]">✅</span> {{ t.benefitOriginal }}
              </div>
              <div class="flex items-center gap-2 bg-white/5 rounded-xl px-3 py-2.5 text-sm text-slate-300 font-medium">
                <span class="text-[#00e676]">✅</span> {{ t.benefitAutoDelivery }}
              </div>
              <div class="flex items-center gap-2 bg-white/5 rounded-xl px-3 py-2.5 text-sm text-slate-300 font-medium">
                <span class="text-[#00e676]">✅</span> {{ t.benefitSupport }}
              </div>
              <div class="flex items-center gap-2 bg-white/5 rounded-xl px-3 py-2.5 text-sm text-slate-300 font-medium">
                <span class="text-[#00e676]">✅</span> {{ t.benefitGuarantee }}
              </div>
            </div>

          </div>
        </div>

        <!-- ÔöÇÔöÇ BANNER URGÊNCIA ÔöÇÔöÇ -->
        <!-- O QUE ESTÁ INCLUÍDO -->
        <div class="mt-10 bg-white border border-gray-200 rounded-2xl p-6 md:p-10 max-w-4xl mx-auto">
          <div class="text-xl font-extrabold text-gray-900 mb-5">{{ t.included }}</div>
          <ul class="grid sm:grid-cols-2 gap-3">
            <li v-for="item in includedItems" :key="item" class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#00e676]/20">
                <svg viewBox="0 0 20 20" fill="currentColor" class="h-3.5 w-3.5 text-[#00e676]">
                  <path fill-rule="evenodd" d="M16.704 5.29a1 1 0 010 1.415l-7.25 7.25a1 1 0 01-1.415 0L3.296 9.21a1 1 0 011.415-1.415l3.018 3.018 6.543-6.543a1 1 0 011.432.02z" clip-rule="evenodd" />
                </svg>
              </span>
              <span class="text-gray-700">{{ item }}</span>
            </li>
          </ul>
        </div>

        <!-- Microsoft 365 info -->
        <div v-if="isMicrosoft365" class="mt-6 bg-white border border-gray-200 rounded-2xl p-6 md:p-10 max-w-4xl mx-auto">
          <div class="font-extrabold text-gray-900 mb-3">{{ t.ms365HowTitle }}</div>
          <ul class="list-disc pl-5 space-y-2 text-gray-700">
            <li>{{ t.ms365Bullet2 }}</li>
            <li>{{ t.ms365Bullet3 }}</li>
          </ul>
          <div class="mt-4 text-gray-600">
            {{ t.ms365HelpPrefix }} <NuxtLink class="text-[#00e676] hover:underline font-semibold" :to="digitalDeliveryPath">{{ t.ms365HelpLink }}</NuxtLink>.
          </div>
        </div>

        <!-- ÔöÇÔöÇ CTA REPETIDO ÔöÇÔöÇ -->
        <div class="mt-10 flex flex-col items-center text-center gap-4">
          <p class="text-sm text-slate-500">{{ t.ctaUrgency }}</p>
          <button
            type="button"
            class="inline-flex items-center gap-3 bg-[#00e676] hover:bg-[#00ff87] active:scale-[0.98] text-[#010d1a] text-lg font-black uppercase tracking-widest px-12 py-4 rounded-xl transition-all duration-200 shadow-[0_0_30px_rgba(0,230,118,0.35)]"
            @click="buyNow"
          >
            {{ t.buyNowBtn }}
          </button>
        </div>

        <!-- TUTORIAL -->
        <div
          v-if="safeProduct.tutorialTitle"
          class="mt-10 bg-white border border-gray-200 rounded-2xl p-6 md:p-10 max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6"
        >
          <div class="flex items-center gap-5">
            <div class="bg-blue-600 text-white p-4 rounded-xl text-xl shrink-0">�</div>
            <div>
              <h3 class="text-lg font-extrabold text-gray-900">{{ t.tutorialCardTitle }}</h3>
              <p class="text-gray-600 text-sm mt-1">{{ safeProduct.tutorialSubtitle }}</p>
              <p v-if="tutorialAccessChecked && !tutorialAccess?.allowed" class="text-amber-600 text-xs mt-2">
                � {{ t.tutorialLoginRequired }}
              </p>
            </div>
          </div>
          <NuxtLink
            v-if="!tutorialAccessChecked || tutorialAccess?.allowed"
            :to="`/tutorials/${safeProduct.slug}`"
            class="shrink-0 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl transition"
          >
            → {{ t.viewTutorial }}
          </NuxtLink>
          <NuxtLink
            v-else
            :to="`/account/login?returnTo=${encodeURIComponent('/tutorials/' + safeProduct.slug)}`"
            class="shrink-0 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-3 rounded-xl transition"
          >
            � {{ t.tutorialLoginRequired }}
          </NuxtLink>
        </div>

        <!-- DESCRIÇÃO DO PRODUTO -->
        <div style="background-color: #ffffff; border: 1px solid #e5e7eb; border-radius: 1rem; margin-top: 2.5rem; padding: 2.5rem; max-width: 56rem; margin-left: auto; margin-right: auto;">
          <h2 style="font-size: 1.5rem; font-weight: 800; color: #111827; margin-bottom: 1.5rem;">Product Description</h2>
          <div style="color: #111827 !important; background-color: #ffffff !important;" v-html="safeDescriptionHtml" />
        </div>

        <!-- POR QUE O PREÇO É BOM -->
        <div class="bg-white border border-gray-200 rounded-2xl mt-6 p-6 md:p-10 max-w-4xl mx-auto">
          <h2 class="text-2xl font-extrabold text-gray-900 mb-4">{{ t.whyPriceTitle }}</h2>
          <p class="text-gray-700 leading-relaxed">{{ t.whyPriceP1 }}</p>
          <p class="text-gray-700 leading-relaxed mt-4">{{ t.whyPriceP2 }}</p>
        </div>

        <!-- SEO content -->
        <div v-if="safeSeoContentHtml" class="mt-8 seo-content-dark">
          <section class="prose prose-invert prose-sm max-w-none text-slate-200" v-html="safeSeoContentHtml" />
        </div>

        <!-- Afiliados -->
        <div
          v-if="affiliateEnabled"
          class="mt-8 bg-white border border-gray-200 rounded-2xl p-6 md:p-10 max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6"
        >
          <div>
            <div class="text-xl font-extrabold text-gray-900">{{ t.affiliateTitle }}</div>
            <div class="mt-1 text-gray-600 text-sm">{{ t.affiliateSub }}</div>
          </div>
          <NuxtLink
            to="/partner-apply"
            class="shrink-0 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl transition"
          >
            {{ t.affiliateBtn }}
          </NuxtLink>
        </div>

        <!-- Avaliações de clientes -->
        <div class="mt-8">
          <ReviewsSection :product-id="safeProduct.id" :limit="3" />
        </div>

        <!-- Produtos relacionados -->
        <div v-if="relatedProducts.length" class="mt-10 bg-white border border-gray-200 rounded-2xl p-6 md:p-10 max-w-4xl mx-auto">
          <h2 class="text-2xl font-extrabold text-gray-900 mb-6">{{ t.relatedProductsTitle || 'Produtos Relacionados' }}</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            <article
              v-for="p in relatedProducts"
              :key="p.slug"
              class="border border-gray-100 rounded-2xl overflow-hidden hover:border-blue-200 hover:shadow-sm transition bg-white"
            >
              <NuxtLink :to="`/product/${p.slugEn || p.slug}`" class="block">
                <div class="bg-gray-100">
                  <img
                    :src="p.image || '/products/placeholder.svg'"
                    :alt="p.name"
                    class="w-full h-36 object-contain p-4"
                    loading="lazy"
                  />
                </div>
                <div class="p-5">
                  <div class="text-base font-extrabold text-gray-900 leading-snug line-clamp-2">{{ p.name }}</div>
                  <div v-if="p.price" class="text-lg font-bold text-blue-600 mt-2">{{ formatProductPrice(p.price, p.currency) }}</div>
                </div>
              </NuxtLink>
            </article>
          </div>
        </div>

      </div>

      <!-- Produto não encontrado -->
      <div v-else class="text-center py-32 text-slate-500">{{ t.notFound }}</div>

    </div>
  </section>
</template>

<script setup lang="ts">
import { useIntlContext } from '~/composables/useIntlContext'
import { trackViewItem } from '~/composables/useTracking'
import { useEcommerceTracking } from '~/composables/useEcommerceTracking'
import { useCart } from '~/composables/useCart'

function safeSanitize(html: string, options?: { ALLOWED_TAGS?: string[]; ALLOWED_ATTR?: string[]; USE_PROFILES?: any }): string {
  const str = String(html || '')
  if (options?.ALLOWED_TAGS?.length === 0) {
    return str.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
  }
  return str
}

definePageMeta({ ssr: true })

const intl = useIntlContext()

const { siteName } = useSiteBranding()

const config = useRuntimeConfig()
const storeSlug = computed(() => String((config.public as any)?.storeSlug || '').trim())

const affiliateEnabled = computed(() => Boolean((config.public as any)?.affiliateEnabled))

// CRITICAL: read host AND path synchronously in setup ÔÇö useRequestURL/useRequestHeaders/useRequestEvent
// only work in synchronous setup context, NOT inside computed (lazy evaluation loses request context)
const { _ssrHost, _ssrPath } = (() => {
  if (import.meta.server) {
    try {
      const url = useRequestURL()
      if (url?.host) return { _ssrHost: String(url.host).toLowerCase(), _ssrPath: String(url.pathname || '') }
    } catch { /* ignore */ }
    try {
      const event = useRequestEvent()
      const rawHost = String(event?.node?.req?.headers?.['x-forwarded-host'] || event?.node?.req?.headers?.host || '')
      const rawPath = String(event?.node?.req?.url || '')
      return {
        _ssrHost: String(rawHost.split(',')[0]?.trim() || '').toLowerCase(),
        _ssrPath: rawPath.split('?')[0] || ''
      }
    } catch { /* ignore */ }
  }
  return { _ssrHost: '', _ssrPath: '' }
})()

const host = import.meta.server
  ? shallowRef(_ssrHost)
  : computed(() => String(window.location.host || '').toLowerCase())

// Client-side: detect intl immediately (not waiting for onMounted) so ClientOnly renders correctly
const _clientIsIntl = ref<boolean | null>((() => {
  if (!import.meta.client) return null
  const h = String(window.location.host || '').toLowerCase()
  if (h.includes('gvgmall') || h.includes('globalsoftware') || h.endsWith('.store')) return true
  if (h.endsWith('.com.br') || h.includes('localhost') || h.includes('127.0.0.1') || h.includes('.vercel.app')) return false
  return true
})())

const normalizedHost = computed(() => {
  const h0 = String(host.value || '').trim().toLowerCase()
  const h1 = h0.replace(/^https?:\/\//, '')
  const h2 = h1.replace(/\/.*/, '')
  const h3 = h2.replace(/:\d+$/, '')
  const h4 = h3.replace(/^www\./, '')
  return h4.replace(/\.$/, '')
})

const { market } = useLocaleCurrency()

// On international domains, always use EN regardless of SSR language detection
// isIntlDomain defined below after route is declared
const effectiveLang = computed(() => {
  // Market selector takes priority
  const marketLang = market.value.language
  if (marketLang && marketLang !== 'pt') return marketLang
  if (isIntlDomain.value) return intl.language.value !== 'pt' ? intl.language.value : 'en'
  return intl.language.value
})

const productsIndexPath = computed(() => (effectiveLang.value === 'en' ? '/products' : '/produtos'))
const categoryPathPrefix = computed(() => (effectiveLang.value === 'en' ? '/category' : '/categoria'))
const digitalDeliveryPath = computed(() => (effectiveLang.value === 'en' ? '/digital-delivery' : '/entrega-digital'))

const isCasaDoSoftware = computed(() => {
  if (normalizedHost.value.includes('casadosoftware.com.br')) return true
  return storeSlug.value === 'casadosoftware'
})

const isLicencasDigitais = computed(() => {
  if (normalizedHost.value.includes('licencasdigitais.com.br')) return true
  return storeSlug.value === 'licencasdigitais'
})

const sectionClass = computed(() => {
  return isLicencasDigitais.value ? 'bg-white min-h-screen' : 'bg-gray-50 min-h-screen py-10'
})

const containerClass = computed(() => {
  return isLicencasDigitais.value ? 'max-w-7xl mx-auto px-6 pt-8 pb-12' : 'max-w-6xl mx-auto px-6'
})

const breadcrumbClass = computed(() => {
  return isLicencasDigitais.value ? 'text-xs text-gray-500 mb-5' : 'text-sm text-gray-500 mb-6'
})

const titleClass = computed(() => {
  return isLicencasDigitais.value
    ? 'text-2xl md:text-3xl font-extrabold text-gray-900 mb-6'
    : 'text-3xl md:text-4xl font-extrabold text-gray-900 mb-8'
})

const mainCardClass = computed(() => {
  return isLicencasDigitais.value
    ? 'bg-white border rounded-2xl p-6 md:p-8 grid lg:grid-cols-2 gap-10'
    : 'bg-white rounded-2xl border border-gray-100 shadow-sm p-8 grid lg:grid-cols-2 gap-10'
})

const imageWrapClass = computed(() => {
  return isLicencasDigitais.value ? 'flex items-center justify-center bg-gray-50 border rounded-2xl p-6' : 'flex items-center justify-center bg-gray-50 rounded-2xl p-6'
})

const buyColumnClass = computed(() => {
  return isLicencasDigitais.value ? 'space-y-6 lg:pl-2' : 'space-y-6'
})

const buyButtonClass = computed(() => {
  return isLicencasDigitais.value
    ? 'w-full bg-blue-600 hover:bg-blue-700 text-white text-base font-bold py-3.5 rounded-md transition'
    : 'w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-lg font-bold py-4 rounded-xl transition shadow-md shadow-blue-200/60'
})

const tutorialCardClass = computed(() => {
  return isLicencasDigitais.value
    ? 'mt-10 border border-blue-200 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 bg-blue-50'
    : 'mt-12 border border-blue-500 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6 bg-blue-50'
})

const descriptionCardClass = computed(() => {
  return isLicencasDigitais.value ? 'bg-white border rounded-2xl mt-10 p-6 md:p-8 space-y-10' : 'bg-white rounded-2xl border border-gray-100 shadow-sm mt-10 p-8 space-y-10'
})

const whyPriceCardClass = computed(() => {
  return isLicencasDigitais.value ? 'bg-white border rounded-2xl mt-8 p-6 md:p-8' : 'bg-white rounded-2xl border border-gray-100 shadow-sm mt-8 p-8'
})

const route = useRoute()
const slug = computed(() => String(route.params.slug || ''))

// Detect intl domain ÔÇö multi-signal: client window > SSR path > SSR host
const isIntlDomain = computed(() => {
  // 1. After onMounted, window.location.host is authoritative
  if (_clientIsIntl.value !== null) return _clientIsIntl.value
  // 2. SSR real request path (/product/ only exists on intl domains)
  if (_ssrPath.startsWith('/product/') || _ssrPath.startsWith('/category/') || _ssrPath.startsWith('/products')) return true
  // 3. Client route.path (same logic, covers client-side navigation)
  const p = String(route.path || '')
  if (p.startsWith('/product/') || p.startsWith('/category/') || p.startsWith('/products')) return true
  // 4. SSR host detection
  const h = normalizedHost.value
  if (!h) return false
  if (h.includes('gvgmall') || h.includes('globalsoftware') || h.endsWith('.store')) return true
  if (h.endsWith('.com.br') || h.includes('localhost') || h.includes('127.0.0.1')) return false
  if (h.includes('.vercel.app')) return false
  return true
})

const { hreflangLinks: productHreflang } = useSeoLocale({
  pageType: 'product',
  slug: computed(() => String((safeProduct as any)?.slug || slug.value || '')),
  slugEn: computed(() => String((safeProduct as any)?.slugEn || ''))
})

const lang = computed(() => effectiveLang.value)

const isClient = import.meta.client

const isOffice365FiveLicenses = computed(() => {
  const s = String(slug.value || '').trim().toLowerCase()
  return s === 'microsoft-office-365-vitalicio-5-licencas-pc-mac-android-ou-ios-1-tb-one-drive'
})

const pageH1 = computed(() => {
  if (isCasaDoSoftware.value && isOffice365FiveLicenses.value) {
    if (effectiveLang.value === 'en') return 'Original Office 365 License for PC and Mac – Instant Delivery'
    if (effectiveLang.value === 'es') return 'Licencia original de Office 365 para PC y Mac – Entrega inmediata'
    return 'Licença Office 365 Original para PC e Mac – Entrega Instantânea'
  }
  return String((safeProduct as any)?.name || '')
})
const baseUrl = useSiteUrl()

const canonicalUrl = computed(() => {
  const s = String(slug.value || '').trim()
  if (!s) return baseUrl ? `${baseUrl}/` : ''

  // IMPORTANT: Always use /produto/ to match public URL
  // The URL accessed by users is /produto/[slug], so canonical must match
  const slugToUse = isIntlDomain.value
    ? (String((safeProduct as any)?.slugEn || '').trim() || s)
    : s

  return baseUrl ? `${baseUrl}/produto/${slugToUse}` : ''
})

const productFetchParams = computed(() => {
  const q = route.query as any
  const queryLang = String(q.lang || lang.value || 'en').trim().toLowerCase()

  const derivedCurrency = (() => {
    const explicitCurrency = String(q.currency || '').trim().toLowerCase()
    if (['usd', 'eur', 'brl', 'gbp'].includes(explicitCurrency)) return explicitCurrency
    if (queryLang === 'pt') return 'brl'
    if (queryLang === 'fr' || queryLang === 'es' || queryLang === 'it' || queryLang === 'de') return 'eur'
    return 'usd'
  })()

  const derivedLocale = (() => {
    if (queryLang === 'pt') return 'pt-BR'
    if (queryLang === 'fr') return 'fr-FR'
    if (queryLang === 'es') return 'es-ES'
    if (queryLang === 'it') return 'it-IT'
    if (queryLang === 'de') return 'de-DE'
    return 'en-US'
  })()

  const derivedCountry = (() => {
    if (queryLang === 'pt') return 'BR'
    if (queryLang === 'fr') return 'FR'
    if (queryLang === 'es') return 'ES'
    if (queryLang === 'it') return 'IT'
    if (queryLang === 'de') return 'DE'
    return 'US'
  })()

  return {
    lang: queryLang,
    currency: derivedCurrency,
    locale: String(q.locale || derivedLocale),
    countryCode: String(q.countryCode || q.country || derivedCountry)
  }
})

const asyncProductKey = computed(() => `product-${slug.value}-${productFetchParams.value.lang}-${productFetchParams.value.currency}-${productFetchParams.value.locale}-${productFetchParams.value.countryCode}`)

const { data: product, pending, error, refresh: refreshProduct } = await useAsyncData(
  asyncProductKey.value,
  async () => {
    const s = String(slug.value || '').trim()
    if (!s) return null

    const data: any = await $fetch(`/api/products/${encodeURIComponent(s)}`, {
      query: productFetchParams.value
    })

    return data?.produto || data
  },
  {
    server: true,
    lazy: false,
    watch: [slug, productFetchParams],
    default: () => null
  }
)

const { data: productsData, refresh: refreshProducts } = await useFetch<any[]>(
  () => `/api/products?currency=${encodeURIComponent(market.value.currencyLower)}&locale=${encodeURIComponent(market.value.locale)}&countryCode=${encodeURIComponent(market.value.code)}`,
  {
    server: true,
    default: () => [],
    watch: [() => market.value.currencyLower, () => market.value.locale, () => market.value.code]
  }
)

watch(() => market.value, () => {
  refreshProduct()
  refreshProducts()
}, { deep: true })

if (import.meta.server && product.value === null && !error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Produto não encontrado' })
}

const safeProduct = computed(() => {
  const p = product.value

  // If no product, return null
  if (!p) return null

  // Normalize Portuguese fields to English
  const normalized = {
    id: p.id,
    name: p.nome || p.name || '',
    slug: p.slug || '',
    slugEn: p.slugEn || '',
    description: p.descricao || p.description || '',
    price: Number(p.preco ?? p.price ?? 0),
    oldPrice: Number(p.precoAntigo ?? p.oldPrice ?? 0) || null,
    currency: p.currency || p.requestedCurrency || productFetchParams.value.currency,
    image: p.imagem || p.image || '/products/placeholder.svg',
    cardItems: p.cardItems || null,
    tutorialTitle: p.tutorialTitulo || p.tutorialTitle || null,
    tutorialSubtitle: p.tutorialSubtitulo || p.tutorialSubtitle || 'Aprenda como ativar seu produto passo a passo com nosso guia completo e detalhado.',
    tutorialContent: p.tutorialConteudo || p.tutorialContent || null,
    seoTitle: p.seoTitle || null,
    seoDescription: p.seoDescription || null,
    seoContent: p.seoContent || null,
    imageAlt: p.imageAlt || null,
    imageTitle: p.imageTitle || null,
    imageCaption: p.imageCaption || null,
    createdAt: p.criadoEm || p.createdAt || null,
    finalUrl: p.finalUrl || null
  }

  console.log('[produto/[slug]] safeProduct normalized:', { price: normalized.price, preco: p.preco, currency: normalized.currency })

  return normalized
})

const tutorialAccess = ref<{ allowed: boolean; reason: string | null } | null>(null)
const tutorialAccessChecked = ref(false)

if (import.meta.client) {
  onMounted(async () => {
    if (!(safeProduct.value as any)?.tutorialTitle) return
    try {
      const res = await $fetch<{ ok: boolean; allowed: boolean; reason: string | null }>(
        `/api/customer/tutorial-access/${slug.value}`
      )
      tutorialAccess.value = { allowed: res.allowed, reason: res.reason ?? null }
    } catch {
      tutorialAccess.value = { allowed: false, reason: 'error' }
    } finally {
      tutorialAccessChecked.value = true
    }
  })
}

const primaryCategorySlug = computed(() => {
  const raw = (safeProduct as any)?.categories
  if (!Array.isArray(raw)) return ''
  const first = String(raw.find((x: any) => String(x || '').trim()) || '').trim()
  return first
})

const primaryCategoryLabel = computed(() => {
  const s = String(primaryCategorySlug.value || '').trim()
  if (!s) return ''
  const pretty = s.replace(/[-_]+/g, ' ').trim()
  return pretty ? (pretty.charAt(0).toUpperCase() + pretty.slice(1)) : s
})

function normalizeTokens(input: unknown): string[] {
  return String(input || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, ' ')
    .split(/\s+/g)
    .map((t) => t.trim())
    .filter((t) => t.length >= 3)
    .slice(0, 12)
}

function formatProductPrice(price: number, currency: string) {
  try {
    const c = String(currency || '').trim().toLowerCase()
    const currencyCode =
      c === 'brl' ? 'BRL' :
      c === 'eur' ? 'EUR' :
      c === 'gbp' ? 'GBP' :
      'USD'

    const locale =
      currencyCode === 'BRL' ? 'pt-BR' :
      currencyCode === 'EUR' ? 'fr-FR' :
      currencyCode === 'GBP' ? 'en-GB' :
      'en-US'

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(price || 0))
  } catch {
    return String(price || 0)
  }
}

const relatedProducts = computed(() => {
  const all: any[] = productsData.value || []
  const currentSlug = String(safeProduct.value?.slug || '')
  const baseTokens = normalizeTokens(safeProduct.value?.name || safeProduct.value?.description || '')
  if (!baseTokens.length) return all.filter((p: any) => p.slug !== currentSlug).slice(0, 4)

  const scored = all
    .filter((p: any) => p.slug !== currentSlug)
    .map((p: any) => {
      const candidate = String(p?.name || '') || String(p?.description || '')
      const tokens = normalizeTokens(candidate)
      const score = tokens.reduce((acc: number, t: string) => (baseTokens.includes(t) ? acc + 1 : acc), 0)
      return { p, score }
    })
    .filter((x: any) => x.score > 0)
    .sort((a: any, b: any) => b.score - a.score)
    .slice(0, 4)
    .map((x: any) => x.p)

  return scored.length ? scored : all.filter((p: any) => p.slug !== currentSlug).slice(0, 4)
})

const { trackViewItem: ecomViewItem, trackAddToCart: ecomAddToCart } = useEcommerceTracking()

const viewItemTracked = ref(false)

watch(
  () => safeProduct,
  (p) => {
    if (!import.meta.client) return
    if (viewItemTracked.value) return
    if (!p || !(p as any).id) return
    viewItemTracked.value = true

    try {
      trackViewItem(p)
      ecomViewItem({
        item_id: (p as any).id,
        item_name: String((p as any).name || (p as any).name || ''),
        price: Number((p as any).price ?? (p as any).price ?? 0),
        item_category: primaryCategoryLabel.value || 'Software'
      }, 'BRL')
    } catch {
      // ignore
    }
  },
  { immediate: true }
)

const safeImage = computed(() => {
  const image = String((safeProduct.value as any)?.image || (safeProduct.value as any)?.imagem || '')
  if (!image || image === '/products/placeholder.svg') return '/products/placeholder.svg'

  if (image.startsWith('http://')) {
    return image.replace(/^http:\/\//, 'https://')
  }

  return image
})

const absoluteImageUrl = computed(() => {
  const raw = String(safeImage.value || '').trim()
  if (!raw) return ''
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw
  const origin = String(baseUrl || '').trim()
  if (!origin) return raw
  if (!raw.startsWith('/')) return `${origin}/${raw}`
  return `${origin}${raw}`
})

const seoTitle = computed(() => {
  const customSeoTitle = String((safeProduct as any)?.seoTitle || '').trim()
  if (customSeoTitle) return customSeoTitle

  const slugValue = String((safeProduct as any)?.slug || slug.value || '').trim().toLowerCase()
  const lang = effectiveLang.value
  const base = String(siteName || 'Casa do Software')

  if (isCasaDoSoftware.value) {
    if (slugValue.includes('windows-11') && slugValue.includes('pro')) {
      if (lang === 'en') return `Windows 11 Pro Original License – Instant Activation | ${base}`
      if (lang === 'es') return `Licencia Windows 11 Pro Original – Activación Inmediata | ${base}`
      if (lang === 'fr') return `Licence Windows 11 Pro Originale – Activation Instantanée | ${base}`
      if (lang === 'it') return `Licenza Windows 11 Pro Originale – Attivazione Immediata | ${base}`
      return `Licença Windows 11 Pro Original – Ativação Imediata | ${base}`
    }
    if (slugValue.includes('windows-10') && slugValue.includes('pro')) {
      if (lang === 'en') return `Windows 10 Pro Original Digital License – Instant Delivery | ${base}`
      if (lang === 'es') return `Licencia Windows 10 Pro Original – Clave Digital Vitalicia | ${base}`
      if (lang === 'fr') return `Licence Windows 10 Pro Originale – Clé Numérique à Vie | ${base}`
      if (lang === 'it') return `Licenza Windows 10 Pro Originale – Chiave Digitale a Vita | ${base}`
      return `Windows 10 Pro Original – Licença Digital Vitalícia | ${base}`
    }
    if (slugValue.includes('office') && (slugValue.includes('365') || slugValue.includes('microsoft-365'))) {
      if (isOffice365FiveLicenses.value) {
        if (lang === 'en') return `Original Microsoft 365 License – 5 Devices, 1TB OneDrive | ${base}`
        if (lang === 'es') return `Licencia Microsoft 365 Original – 5 Dispositivos, 1TB OneDrive | ${base}`
        if (lang === 'fr') return `Licence Microsoft 365 Originale – 5 Appareils, 1To OneDrive | ${base}`
        if (lang === 'it') return `Licenza Microsoft 365 Originale – 5 Dispositivi, 1TB OneDrive | ${base}`
        return `Licença Microsoft 365 Original PC e Mac | Entrega imediata`
      }
      if (lang === 'en') return `Buy Microsoft Office 365 License – Instant Delivery | ${base}`
      if (lang === 'es') return `Comprar Licencia Microsoft Office 365 – Entrega Inmediata | ${base}`
      if (lang === 'fr') return `Acheter Licence Microsoft Office 365 – Livraison Instantanée | ${base}`
      if (lang === 'it') return `Acquista Licenza Microsoft Office 365 – Consegna Immediata | ${base}`
      return `Office 365 Original – Licença Oficial com Entrega Imediata`
    }
  }
  const name = String((safeProduct as any)?.name || '').trim()
  if (name) {
    // For casadosoftware.com.br, always use Portuguese
    if (isCasaDoSoftware.value) {
      return `${name} | Licença Digital + Acesso Imediato | ${base}`
    }
    if (lang === 'en') return `Buy ${name} – Instant Digital Delivery | ${base}`
    if (lang === 'es') return `Comprar ${name} – Entrega Digital Inmediata | ${base}`
    if (lang === 'fr') return `Acheter ${name} – Livraison Numérique Instantanée | ${base}`
    if (lang === 'it') return `Acquista ${name} – Consegna Digitale Immediata | ${base}`
    return `${name} | ${base}`
  }
  return base
})

const seoDescription = computed(() => {
  const customSeoDesc = String((safeProduct as any)?.seoDescription || '').trim()
  if (customSeoDesc) return customSeoDesc

  const slugValue = String((safeProduct as any)?.slug || slug.value || '').trim().toLowerCase()
  const lang = effectiveLang.value

  if (isCasaDoSoftware.value) {
    // For casadosoftware.com.br, always use Portuguese
    if (slugValue.includes('windows-11') && slugValue.includes('pro')) {
      return 'Windows 11 Pro original com chave vitalícia e entrega na hora. Instale e ative em minutos com suporte completo. Compra segura!'
    }
    if (slugValue.includes('windows-10') && slugValue.includes('pro')) {
      return 'Windows 10 Pro Original – Licença Digital Vitalícia. Ativação imediata, instalação simples e suporte completo. Entrega por e-mail!'
    }
    if (slugValue.includes('office') && (slugValue.includes('365') || slugValue.includes('microsoft-365'))) {
      if (isOffice365FiveLicenses.value) {
        return 'Licença Microsoft 365 Original PC e Mac – Entrega imediata. Ative em até 5 dispositivos, 1TB OneDrive, conta oficial e suporte completo.'
      }
      return 'Office 365 Original – Licença Oficial com Entrega Imediata. Ative em minutos, conta oficial e suporte completo. Entrega por e-mail!'
    }
  }

  // For international domains or other stores
  if (slugValue.includes('windows-11') && slugValue.includes('pro')) {
    if (lang === 'en') return 'Buy Windows 11 Pro original license with secure checkout and instant email delivery. Install and activate in minutes with customer support. Secure payment!'
    if (lang === 'es') return '¡Compra tu licencia original de Windows 11 Pro con activación segura y entrega inmediata por email. Instala y activa en minutos con soporte al cliente!'
    if (lang === 'fr') return 'Achetez votre licence Windows 11 Pro originale avec paiement sécurisé et livraison instantanée par email. Installation simple avec assistance client!'
    if (lang === 'it') return 'Acquista la licenza originale di Windows 11 Pro con checkout sicuro e consegna immediata via email. Attiva in pochi minuti con supporto clienti!'
    return 'Windows 11 Pro original com ativação segura e entrega imediata por email. Instale e ative em minutos com suporte ao cliente. Compra segura!'
  }
  if (slugValue.includes('windows-10') && slugValue.includes('pro')) {
    if (lang === 'en') return 'Buy Windows 10 Pro original license with secure checkout, email delivery and customer support. Digital license for PC or laptop. Activation included!'
    if (lang === 'es') return 'Compra Windows 10 Pro original con activación segura y soporte al cliente. Licencia digital para PC o portátil. ¡Entrega por email!'
    if (lang === 'fr') return 'Achetez Windows 10 Pro original avec paiement sécurisé et support client. Licence numérique pour PC ou ordinateur portable. Livraison par email!'
    if (lang === 'it') return 'Acquista Windows 10 Pro originale con checkout sicuro e supporto clienti. Licenza digitale per PC o laptop. Consegna via email!'
    return 'Compre Windows 10 Pro original com checkout seguro e suporte ao cliente. Licença digital para PC ou notebook. Entrega por email!'
  }
  if (slugValue.includes('office') && (slugValue.includes('365') || slugValue.includes('microsoft-365'))) {
    if (isOffice365FiveLicenses.value) {
      if (lang === 'en') return 'Buy original Microsoft 365 license for up to 5 devices. Fast activation, official account, 1TB OneDrive storage. Instant delivery by email!'
      if (lang === 'es') return 'Compra tu licencia Microsoft 365 original para hasta 5 dispositivos. Activación rápida, cuenta oficial y 1TB de almacenamiento. ┬íEntrega inmediata!'
      if (lang === 'fr') return 'Achetez votre licence Microsoft 365 originale pour jusqu\'à 5 appareils. Activation rapide, compte officiel, 1To OneDrive. Livraison instantanée!'
      if (lang === 'it') return 'Acquista la tua licenza Microsoft 365 originale per fino a 5 dispositivi. Attivazione rapida, account ufficiale, 1TB OneDrive. Consegna immediata!'
      return 'Comprar licença do pacote Office permanente nunca foi tão fácil. Original, ativação rápida, conta oficial, suporte completo e envio imediato por email.'
    }
    if (lang === 'en') return 'Original Microsoft Office 365 for PC and Mac. Fast activation, official account and full support. Get it now by email!'
    if (lang === 'es') return 'Microsoft Office 365 original para PC y Mac. Activación rápida, cuenta oficial y soporte completo. ┬íRecíbelo ahora por email!'
    if (lang === 'fr') return 'Microsoft Office 365 original pour PC et Mac. Activation rapide, compte officiel et support complet. Recevez-le maintenant par email!'
    if (lang === 'it') return 'Microsoft Office 365 originale per PC e Mac. Attivazione rapida, account ufficiale e supporto completo. Ricevilo ora per email!'
    return 'Microsoft Office 365 original para PC e Mac. Ativação rápida, conta oficial e suporte completo. Receba agora por e-mail!'
  }
  if (slugValue.includes('office') && slugValue.includes('2021')) {
    if (lang === 'en') return 'Buy Microsoft Office 2021 original with permanent key and simple installation. Instant delivery and secure payment. Activate in minutes!'
    if (lang === 'es') return '┬íCompra Microsoft Office 2021 original con clave permanente e instalación simple. Entrega inmediata y pago seguro. Actívalo en minutos!'
    if (lang === 'fr') return 'Achetez Microsoft Office 2021 original avec clé permanente et installation simple. Livraison instantanée et paiement sécurisé. Activez en minutes!'
    if (lang === 'it') return 'Acquista Microsoft Office 2021 originale con chiave permanente e installazione semplice. Consegna immediata e pagamento sicuro. Attiva in minuti!'
    return 'Licença Office 2021 original com chave permanente e instalação simples. Entrega imediata e pagamento seguro. Ative em minutos!'
  }

  const rawShort = String((safeProduct as any)?.description || '').trim()
  const rawLong = String((safeProduct as any)?.descricao || '').trim()

  const raw = rawShort || rawLong
  if (!raw) return ''

  const textOnly = safeSanitize(raw, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })
    .replace(/\s+/g, ' ')
    .trim()

  return textOnly.length > 155 ? textOnly.slice(0, 155) : textOnly
})

useHead(() => {
  const title = seoTitle.value
  const description = seoDescription.value
  const selfCanonical = canonicalUrl.value
  const link: any[] = [
    ...(selfCanonical ? [{ rel: 'canonical', href: selfCanonical }] : []),
    ...(productHreflang.value as any[])
  ]

  const p = safeProduct as any
  const hasProduct = !pending.value && !error.value && String(p?.name || '').trim()

  if (!hasProduct) {
    return {
      title,
      meta: [{ name: 'description', content: description }],
      link
    }
  }

  const price = Number(p?.price || 0)
  const priceCurrency = String(p?.currency || intl.currency.value || 'BRL').trim().toUpperCase()

  const productJsonLd: any = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: String(p?.name || '').trim() || undefined,
    description: String(description || '').trim() || undefined,
    image: absoluteImageUrl.value ? [absoluteImageUrl.value] : undefined,
    sku: String(p?.id || '').trim() || undefined,
    brand: {
      '@type': 'Brand',
      name: String(siteName || 'Casa do Software')
    },
    offers: {
      '@type': 'Offer',
      url: canonicalUrl.value || undefined,
      priceCurrency,
      price: price > 0 ? price : undefined,
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition'
    }
  }

  const homeUrl = selfCanonical ? selfCanonical.replace(/\/(?:en|es|fr|it)\/.*|\/produto\/.*|\/product\/.*|\/producto\/.*|\/produit\/.*|\/prodotto\/.*/, '/') : '/'
  const breadcrumbJsonLd: any = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: siteName || 'Casa do Software', item: homeUrl },
      { '@type': 'ListItem', position: 2, name: String(p?.name || '').trim() || 'Produto', item: selfCanonical || '' }
    ]
  }

  return {
    title,
    meta: [{ name: 'description', content: description }],
    link,
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify([productJsonLd, breadcrumbJsonLd])
      }
    ]
  }
})

const seoMetaTitle = computed(() => seoTitle.value)
const seoMetaDescription = computed(() => seoDescription.value)
useSeoMeta({
  title: seoMetaTitle,
  description: seoMetaDescription,
  ogTitle: seoMetaTitle,
  ogDescription: seoMetaDescription,
  twitterTitle: seoMetaTitle,
  twitterDescription: seoMetaDescription
})

const safeDescriptionHtml = computed(() => {
  const raw = String((safeProduct.value as any)?.description || '').trim()
  if (!raw) return ''

  const hasHtml = /<\s*\/?\s*[a-z][\s\S]*>/i.test(raw)
  const escapeHtml = (s: string) =>
    s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  const isSimpleHtmlForConversion = (html: string) => {
    // Consider HTML "simple" when it only uses wrappers / line-break tags.
    // In this case we can safely convert it back to text lines and apply ##/### headings.
    const stripped = html
      .replace(/<\s*br\b[^>]*>/gi, '')
      .replace(/<\/?\s*(p|div|span)\b[^>]*>/gi, '')
      .trim()

    return !/<\s*\/?\s*[a-z][\s\S]*>/i.test(stripped)
  }

  const htmlToTextLines = (html: string) => {
    return html
      .replace(/<\s*br\b[^>]*>/gi, '\n')
      .replace(/<\s*\/\s*(p|div)\s*>/gi, '\n')
      .replace(/<\s*(p|div)\b[^>]*>/gi, '')
      .replace(/<\/?\s*span\b[^>]*>/gi, '')
      .replace(/&nbsp;/gi, ' ')
  }

  const convertHeadingsInsideHtml = (html: string) => {
    let out = html

    // Handle common block wrappers.
    out = out.replace(
      /<(p|div|li|span)(\s[^>]*)?>\s*###\s*([\s\S]*?)\s*<\/\1>/gi,
      '<h3>$3</h3>'
    )
    out = out.replace(
      /<(p|div|li|span)(\s[^>]*)?>\s*##\s*([\s\S]*?)\s*<\/\1>/gi,
      '<h2>$3</h2>'
    )

    // Handle cases where the marker is wrapped by inner tags (e.g. <p><strong>## Title</strong></p>).
    out = out.replace(
      /<(p|div|li|span)(\s[^>]*)?>\s*(?:<[^>]+>\s*)*###\s*([\s\S]*?)\s*(?:<\/[^>]+>\s*)*<\/\1>/gi,
      '<h3>$3</h3>'
    )
    out = out.replace(
      /<(p|div|li|span)(\s[^>]*)?>\s*(?:<[^>]+>\s*)*##\s*([\s\S]*?)\s*(?:<\/[^>]+>\s*)*<\/\1>/gi,
      '<h2>$3</h2>'
    )

    // Handle headings after line breaks (keeps the rest of the HTML intact).
    // Capture until the next <br ...> so the heading content may contain tags (e.g. <strong>).
    out = out.replace(
      /(<\s*br\b[^>]*>\s*)###\s*([\s\S]*?)(?=<\s*br\b[^>]*>|$)/gi,
      '$1<h3>$2</h3>'
    )
    out = out.replace(
      /(<\s*br\b[^>]*>\s*)##\s*([\s\S]*?)(?=<\s*br\b[^>]*>|$)/gi,
      '$1<h2>$2</h2>'
    )

    // Handle headings right after an opening tag (e.g. <p>## Title<br ...> or <p><strong>## Title</strong><br ...>).
    // We stop at the next <br ...> or end-of-block to avoid swallowing subsequent content.
    out = out.replace(
      /(>\s*)(?:<[^>]+>\s*)*###\s*([\s\S]*?)(?=<\s*br\b[^>]*>|<\/\s*(p|div|li|span)\b|$)/gi,
      '$1<h3>$2</h3>'
    )
    out = out.replace(
      /(>\s*)(?:<[^>]+>\s*)*##\s*([\s\S]*?)(?=<\s*br\b[^>]*>|<\/\s*(p|div|li|span)\b|$)/gi,
      '$1<h2>$2</h2>'
    )

    // Handle headings at the beginning of the HTML.
    out = out.replace(/^\s*###\s*([^<\n\r]+)/i, '<h3>$1</h3>')
    out = out.replace(/^\s*##\s*([^<\n\r]+)/i, '<h2>$1</h2>')

    return out
  }

  const renderPlainText = (text: string) => {
    const lines = text.replace(/\r\n/g, '\n').split('\n')
    return lines
      .map((line) => {
        if (isCasaDoSoftware.value) {
          const h3 = line.match(/^\s*###\s*(.+)\s*$/)
          if (h3) return `<h3>${escapeHtml(h3[1] || '')}</h3>`

          const h2 = line.match(/^\s*##\s*(.+)\s*$/)
          if (h2) return `<h2>${escapeHtml(h2[1] || '')}</h2>`
        }

        return escapeHtml(line)
      })
      .join('<br />')
  }

  const normalized = (() => {
    if (!hasHtml) return renderPlainText(raw)

    if (isCasaDoSoftware.value && isSimpleHtmlForConversion(raw)) {
      return renderPlainText(htmlToTextLines(raw))
    }

    if (isCasaDoSoftware.value && /##|###/.test(raw)) {
      return convertHeadingsInsideHtml(raw)
    }

    return raw
  })()

  return safeSanitize(normalized, {
    USE_PROFILES: { html: true }
  })
})

const safeSeoContentHtml = computed(() => {
  const raw = String((safeProduct as any)?.seoContent || '').trim()
  if (!raw) return ''

  // Evita duplicar na página o mesmo conteúdo já exibido em safeDescriptionHtml.
  const normalizeForCompare = (value: string) => String(value || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()

  const seoText = normalizeForCompare(raw)
  const descriptionText = normalizeForCompare(
    String((safeProduct as any)?.description || (safeProduct as any)?.descricao || '')
  )

  if (seoText && descriptionText) {
    if (seoText === descriptionText) return ''

    const minLen = Math.min(seoText.length, descriptionText.length)
    const maxLen = Math.max(seoText.length, descriptionText.length)

    // Se um conteúdo contém quase todo o outro, considera duplicado.
    if (minLen > 120 && maxLen > 0) {
      const containsDuplicate = seoText.includes(descriptionText) || descriptionText.includes(seoText)
      const sizeRatio = minLen / maxLen

      if (containsDuplicate && sizeRatio > 0.65) return ''
    }
  }

  return safeSanitize(raw, {
    USE_PROFILES: { html: true }
  })
})

function onImageError(e: Event) {
  const el = e.target as HTMLImageElement | null
  if (!el) return
  if (el.src.endsWith('/products/placeholder.svg')) return
  el.src = '/products/placeholder.svg'
}

function localeForCurrency(currency: string): string {
  const c = String(currency || '').toUpperCase()
  if (c === 'BRL') return 'pt-BR'
  if (c === 'EUR') return 'de-DE'
  if (c === 'GBP') return 'en-GB'
  return 'en-US'
}

const effectiveCurrencyLower = computed(() => {
  const c = String((safeProduct.value as any)?.currency || '').trim().toLowerCase()
  if (c === 'usd' || c === 'eur' || c === 'brl' || c === 'gbp') return c
  // GVGmall default fallback is USD, never BRL
  return 'usd'
})

const isBrl = computed(() => effectiveCurrencyLower.value === 'brl')

const formattedPrice = computed(() => {
  const currency = effectiveCurrencyLower.value.toUpperCase()
  return new Intl.NumberFormat(localeForCurrency(currency), {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number((safeProduct.value as any)?.price || 0))
})

const formattedOldPrice = computed(() => {
  const oldPrice = (safeProduct.value as any)?.oldPrice
  if (!oldPrice || Number.isNaN(Number(oldPrice))) return null
  if (Number(oldPrice) <= Number((safeProduct.value as any)?.price || 0)) return null

  const currency = effectiveCurrencyLower.value.toUpperCase()
  return new Intl.NumberFormat(localeForCurrency(currency), {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(oldPrice))
})

const discountPercent = computed(() => {
  const oldPrice = (safeProduct.value as any)?.oldPrice
  const current = Number((safeProduct.value as any)?.price || 0)
  if (!oldPrice || !current) return null
  const oldN = Number(oldPrice)
  if (!oldN || oldN <= current) return null
  return Math.round((1 - current / oldN) * 100)
})

const formattedPixPrice = computed(() => {
  if (!isBrl.value) return null
  const price = Number((safeProduct.value as any)?.price || 0)
  if (!price) return null
  const pixPrice = Math.round(price * 0.95 * 100) / 100
  if (pixPrice === price) return null
  return pixPrice.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
})

const installments12 = computed(() => {
  if (!isBrl.value) return null
  const price = Number((safeProduct.value as any)?.price || 0)
  if (!price) return null
  const value = Math.round((price / 12) * 100) / 100
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
})

const defaultIncludedItems = computed(() => {
  if (effectiveLang.value === 'en') {
    return [
      'Fast delivery after confirmation',
      'Permanent digital license',
      'Business hours support',
      '1 PC',
      'Professional version with advanced features',
      'Compatible with Windows 10 and 11',
      'Permanent activation',
      'No renewal required'
    ]
  }

  if (effectiveLang.value === 'es') {
    return [
      'Envío rápido tras la confirmación',
      'Licencia digital permanente',
      'Soporte en horario comercial',
      '1 PC',
      'Versión profesional con funciones avanzadas',
      'Compatible con Windows 10 y 11',
      'Activación permanente',
      'Sin renovación'
    ]
  }

  if (effectiveLang.value === 'it') {
    return [
      'Consegna rapida dopo la conferma',
      'Licenza digitale permanente',
      'Supporto negli orari di ufficio',
      '1 PC',
      'Versione professionale con funzionalità avanzate',
      'Compatibile con Windows 10 e 11',
      'Attivazione permanente',
      'Nessun rinnovo necessario'
    ]
  }

  if (effectiveLang.value === 'fr') {
    return [
      'Livraison rapide apr├¿s confirmation',
      'Licence numérique permanente',
      'Support pendant les heures ouvrées',
      '1 PC',
      'Version professionnelle avec fonctionnalités avancées',
      'Compatible avec Windows 10 et 11',
      'Activation permanente',
      'Aucun renouvellement requis'
    ]
  }

  return [
    'Envio imediato após confirmação',
    'Licença digital permanente',
    'Suporte em horário comercial',
    '1 PC',
    'Versão profissional com recursos avançados',
    'Compatível Windows 10 e 11',
    'Ativação permanente',
    'Sem renovação necessária'
  ]
})

const includedItems = computed(() => {
  const raw = String((safeProduct as any)?.cardItems ?? '').trim()
  if (!raw) return defaultIncludedItems.value
  const items = raw
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter(Boolean)
  if (!items.length) return defaultIncludedItems.value

  if (effectiveLang.value === 'pt') return items

  const dictEn: Record<string, string> = {
    'Envio imediato após confirmação': 'Fast delivery after confirmation',
    'Envio rápido após confirmação': 'Fast delivery after confirmation',
    'Licença digital permanente': 'Permanent digital license',
    'Licença digital com ativação permanente': 'Digital license with permanent activation',
    'Licença digital': 'Digital license',
    'Suporte 24/7': '24/7 support',
    'Suporte em horário comercial': 'Business hours support',
    '1 PC': '1 PC',
    'Compatível Windows 10 e 11': 'Compatible with Windows 10 and 11',
    'Ativação permanente': 'Permanent activation',
    'Sem renovação necessária': 'No renewal required',
    'Sem renovação': 'No renewal required',
    'Versão profissional com recursos avançados': 'Professional version with advanced features',
    'Acesso digital com conta ativa': 'Digital access with active account',
    'Uso durante o período contratado': 'Use during contracted period',
    'Uso contínuo sem mensalidade': 'Continuous use, no monthly fee',
    '5 PC , MAC , IOS , Tablet e Celular': '5 PCs, Mac, iOS, Tablet and Mobile',
    '5 PC , MAC , iOS , Tablet e Celular': '5 PCs, Mac, iOS, Tablet and Mobile',
    '5 PC, MAC , IOS , Tablet e Celular': '5 PCs, Mac, iOS, Tablet and Mobile',
    '5 PC, MAC , iOS , Tablet e Celular': '5 PCs, Mac, iOS, Tablet and Mobile',
    '5 PC, MAC, iOS, Tablet e Celular': '5 PCs, Mac, iOS, Tablet and Mobile',
    '5 PC, MAC, IOS, Tablet e Celular': '5 PCs, Mac, iOS, Tablet and Mobile',
    'Atualização gratuita': 'Free updates',
    'Atualizações gratuitas': 'Free updates',
    'Sem mensalidade': 'No monthly fee',
    'Uso vitalício': 'Lifetime use',
    'Chave ESD': 'ESD Key',
    'Instalação simples': 'Easy installation'
  }

  const dictEs: Record<string, string> = {
    'Envio imediato após confirmação': 'Envío rápido tras la confirmación',
    'Envio rápido após confirmação': 'Envío rápido tras la confirmación',
    'Licença digital permanente': 'Licencia digital permanente',
    'Licença digital com ativação permanente': 'Licencia digital con activación permanente',
    'Licença digital': 'Licencia digital',
    'Suporte 24/7': 'Soporte 24/7',
    'Suporte em horário comercial': 'Soporte en horario comercial',
    '1 PC': '1 PC',
    'Compatível Windows 10 e 11': 'Compatible con Windows 10 y 11',
    'Ativação permanente': 'Activación permanente',
    'Sem renovação necessária': 'Sin renovación',
    'Sem renovação': 'Sin renovación',
    'Versão profissional com recursos avançados': 'Versión profesional con funciones avanzadas',
    'Acesso digital com conta ativa': 'Acceso digital con cuenta activa',
    'Uso durante o período contratado': 'Uso durante el período contratado',
    'Uso contínuo sem mensalidade': 'Uso continuo sin mensualidad',
    'Atualização gratuita': 'Actualización gratuita',
    'Atualizações gratuitas': 'Actualizaciones gratuitas',
    'Sem mensalidade': 'Sin mensualidad',
    'Uso vitalício': 'Uso de por vida',
    'Chave ESD': 'Clave ESD',
    'Instalação simples': 'Instalación sencilla'
  }

  const dictIt: Record<string, string> = {
    'Envio imediato após confirmação': 'Consegna rapida dopo la conferma',
    'Envio rápido após confirmação': 'Consegna rapida dopo la conferma',
    'Licença digital permanente': 'Licenza digitale permanente',
    'Licença digital com ativação permanente': 'Licenza digitale con attivazione permanente',
    'Licença digital': 'Licenza digitale',
    'Suporte 24/7': 'Supporto 24/7',
    'Suporte em horário comercial': 'Supporto negli orari di ufficio',
    '1 PC': '1 PC',
    'Compatível Windows 10 e 11': 'Compatibile con Windows 10 e 11',
    'Ativação permanente': 'Attivazione permanente',
    'Sem renovação necessária': 'Nessun rinnovo necessario',
    'Sem renovação': 'Nessun rinnovo necessario',
    'Versão profissional com recursos avançados': 'Versione professionale con funzionalità avanzate',
    'Acesso digital com conta ativa': 'Accesso digitale con account attivo',
    'Uso durante o período contratado': 'Utilizzo durante il periodo contrattuale',
    'Uso contínuo sem mensalidade': 'Uso continuato senza canone mensile',
    'Atualização gratuita': 'Aggiornamento gratuito',
    'Atualizações gratuitas': 'Aggiornamenti gratuiti',
    'Sem mensalidade': 'Nessun canone mensile',
    'Uso vitalício': 'Uso a vita',
    'Chave ESD': 'Chiave ESD',
    'Instalação simples': 'Installazione semplice'
  }

  const dictFr: Record<string, string> = {
    'Envio imediato após confirmação': 'Livraison rapide apr├¿s confirmation',
    'Envio rápido após confirmação': 'Livraison rapide apr├¿s confirmation',
    'Licença digital permanente': 'Licence numérique permanente',
    'Licença digital com ativação permanente': 'Licence numérique avec activation permanente',
    'Licença digital': 'Licence numérique',
    'Suporte 24/7': 'Support 24/7',
    'Suporte em horário comercial': 'Support pendant les heures ouvrées',
    '1 PC': '1 PC',
    'Compatível Windows 10 e 11': 'Compatible avec Windows 10 et 11',
    'Ativação permanente': 'Activation permanente',
    'Sem renovação necessária': 'Aucun renouvellement requis',
    'Sem renovação': 'Aucun renouvellement requis',
    'Versão profissional com recursos avançados': 'Version professionnelle avec fonctionnalités avancées',
    'Acesso digital com conta ativa': 'Acc├¿s numérique avec compte actif',
    'Uso durante o período contratado': "Utilisation pendant la durée du contrat",
    'Uso contínuo sem mensalidade': 'Utilisation continue sans abonnement mensuel',
    'Atualização gratuita': 'Mise à jour gratuite',
    'Atualizações gratuitas': 'Mises à jour gratuites',
    'Sem mensalidade': 'Sans abonnement mensuel',
    'Uso vitalício': 'Utilisation à vie',
    'Chave ESD': 'Clé ESD',
    'Instalação simples': 'Installation simple'
  }

  const lang = effectiveLang.value
  const dict = lang === 'en' ? dictEn : lang === 'es' ? dictEs : lang === 'it' ? dictIt : dictFr

  function looksLikePt(s: string): boolean {
    return /[ãçõ]|após|contratado|vitalí|mensalidade|imediato|horário|comercial|ativação|atualiz|instala|gratuita|simples|contínuo/i.test(s)
  }

  return items
    .map((it) => dict[it] ?? (looksLikePt(it) ? '' : it))
    .filter(Boolean)
})

const isMicrosoft365 = computed(() => {
  const name = String((safeProduct as any)?.name || '').toLowerCase()
  const slugValue = String((safeProduct as any)?.slug || '').toLowerCase()
  return (
    name.includes('microsoft 365') ||
    name.includes('office 365') ||
    slugValue.includes('microsoft-365') ||
    slugValue.includes('office-365') ||
    slugValue.includes('365')
  )
})

const t = computed(() => {
  const lang = effectiveLang.value
  if (lang === 'en') {
    return {
      home: 'Home',
      products: 'Products',
      loading: 'Loading product...',
      notFound: 'Product not found.',
      buy: 'Buy',
      addToCartBtn: 'Add to Cart',
      included: 'What is included:',
      installmentsPrefix: 'up to 12x of',
      pixLabel: 'Payment via PIX',
      digitalDelivery: 'Digital delivery — Available',
      freeRefund: 'Free refund. Up to 7 days from receipt',
      guarantee: 'Guaranteed purchase. Satisfaction or money back',
      emailDelivery: 'Email delivery after confirmation',
      tutorialCardTitle: 'Activation Tutorial',
      viewTutorial: 'View Tutorial',
      tutorialLoginRequired: 'Login to access',
      detailedDescription: 'Detailed Description',
      whyPriceTitle: 'Why is the price so good? Understand.',
      whyPriceP1: 'Our prices are more accessible because we work with digital distribution, without physical media costs, logistics or intermediaries.',
      whyPriceP2: 'This allows us to offer competitive prices, maintaining support and immediate delivery after confirmation.',
      ms365HowTitle: 'Microsoft 365 / Office 365 – how it works',
      ms365Bullet1: '',
      ms365Bullet2: 'Delivery via provided account (login and password) after payment confirmation.',
      ms365Bullet3: 'Access is made with the provided account (not activation on an existing personal Microsoft account).',
      ms365HelpPrefix: 'Questions? Check',
      ms365HelpLink: 'Digital delivery',
      urgencyBadge: '🔥 Limited time offer',
      buyNowBtn: '🛒 BUY NOW',
      microInstant: 'Instant delivery',
      microActivation: 'Activation in minutes',
      microSecure: 'Secure purchase',
      benefitOriginal: 'Original license',
      benefitAutoDelivery: 'Automatic delivery',
      benefitSupport: 'Support included',
      relatedProductsTitle: 'Related Products',
      benefitGuarantee: '7-day guarantee',
      trustSecure: 'Secure purchase',
      trustVerified: 'Verified product',
      trustClients: '+1000 customers',
      trustFastDelivery: 'Immediate delivery',
      urgencyStock: ' Limited digital stock – secure yours now before it runs out!',
      ctaUrgency: '🔥 Don\'t miss this offer – price may change at any time',
      ctaPayment: 'Secure payment',
      ctaEmail: 'Email delivery',
      ctaGuarantee: '7-day guarantee',
      affiliateTitle: 'Earn money recommending this product.',
      affiliateSub: 'Become an affiliate.',
      affiliateBtn: 'I want to register'
    }
  }
  if (lang === 'es') {
    return {
      home: 'Inicio',
      products: 'Productos',
      loading: 'Cargando producto...',
      notFound: 'Producto no encontrado.',
      buy: 'Comprar',
      addToCartBtn: 'Añadir al carrito',
      included: 'Qué está incluido:',
      installmentsPrefix: 'hasta 12x de',
      pixLabel: 'Pago vía PIX',
      digitalDelivery: 'Entrega digital — Disponible',
      freeRefund: 'Reembolso gratis. Hasta 7 días desde el recibo',
      guarantee: 'Compra garantizada. Satisfacción o devolución de dinero',
      emailDelivery: 'Entrega por correo electrónico después de confirmación',
      tutorialCardTitle: 'Tutorial de Activación',
      viewTutorial: 'Ver Tutorial',
      tutorialLoginRequired: 'Inicia sesión para acceder',
      detailedDescription: 'Descripción Detallada',
      whyPriceTitle: '¿Por qué el precio es tan bueno? Entienda.',
      whyPriceP1: 'Nuestros precios son más accesibles porque trabajamos con distribución digital, sin costos de medios físicos, logística o intermediarios.',
      whyPriceP2: 'Esto nos permite ofrecer precios competitivos, manteniendo soporte y envío inmediato después de confirmación.',
      ms365HowTitle: 'Microsoft 365 / Office 365 – cómo funciona',
      ms365Bullet1: '',
      ms365Bullet2: 'Entrega por cuenta proporcionada (login y contraseña) después de la confirmación del pago.',
      ms365Bullet3: 'El acceso se hace con la cuenta proporcionada (no es activación en una cuenta Microsoft personal ya existente).',
      ms365HelpPrefix: '¿Dudas? Consulte',
      ms365HelpLink: 'Entrega digital',
      urgencyBadge: '🔥 Oferta por tiempo limitado',
      buyNowBtn: '🛒 COMPRAR AHORA',
      microInstant: 'Entrega inmediata',
      microActivation: 'Activación en minutos',
      microSecure: 'Compra segura',
      benefitOriginal: 'Licencia original',
      benefitAutoDelivery: 'Entrega automática',
      benefitSupport: 'Soporte incluido',
      relatedProductsTitle: 'Productos Relacionados',
      benefitGuarantee: 'Garantía de 7 días',
      trustSecure: 'Compra segura',
      trustVerified: 'Producto verificado',
      trustClients: '+1000 clientes',
      trustFastDelivery: 'Envío inmediato',
      urgencyStock: ' Stock digital limitado – asegure el suyo ahora antes de que se agote!',
      ctaUrgency: '🔥 No pierda esta oferta – el precio puede cambiar en cualquier momento',
      ctaPayment: 'Pago seguro',
      ctaEmail: 'Entrega por correo electrónico',
      ctaGuarantee: '7 días de garantía',
      affiliateTitle: 'Gane dinero recomendando este producto.',
      affiliateSub: 'Conviértase en afiliado.',
      affiliateBtn: 'Quiero registrarme'
    }
  }
  if (lang === 'fr') {
    return {
      home: 'Accueil',
      products: 'Produits',
      loading: 'Chargement du produit...',
      notFound: 'Produit non trouvé.',
      buy: 'Acheter',
      addToCartBtn: 'Ajouter au panier',
      included: 'Ce qui est inclus:',
      installmentsPrefix: 'jusqu\'à 12x de',
      pixLabel: 'Paiement via PIX',
      digitalDelivery: 'Livraison numérique — Disponible',
      freeRefund: 'Remboursement gratuit. Jusqu\'à 7 jours après réception',
      guarantee: 'Achat garanti. Satisfaction ou remboursement',
      emailDelivery: 'Livraison par e-mail après confirmation',
      tutorialCardTitle: 'Tutoriel d\'Activation',
      viewTutorial: 'Voir le Tutoriel',
      tutorialLoginRequired: 'Connectez-vous pour accéder',
      detailedDescription: 'Description Détaillée',
      whyPriceTitle: 'Pourquoi le prix est-il si bon? Comprenez.',
      whyPriceP1: 'Nos prix sont plus accessibles car nous travaillons avec la distribution numérique, sans coûts de supports physiques, de logistique ou d\'intermédiaires.',
      whyPriceP2: 'Cela nous permet d\'offrir des prix compétitifs, tout en maintenant le support et la livraison immédiate après confirmation.',
      ms365HowTitle: 'Microsoft 365 / Office 365 – comment ça marche',
      ms365Bullet1: '',
      ms365Bullet2: 'Livraison via compte fourni (login et mot de passe) après confirmation du paiement.',
      ms365Bullet3: 'L\'accès se fait avec le compte fourni (pas d\'activation sur un compte Microsoft personnel existant).',
      ms365HelpPrefix: 'Questions? Consultez',
      ms365HelpLink: 'Livraison numérique',
      urgencyBadge: '🔥 Offre à durée limitée',
      buyNowBtn: '🛒 ACHETER MAINTENANT',
      microInstant: 'Livraison immédiate',
      microActivation: 'Activation en minutes',
      microSecure: 'Achat sécurisé',
      benefitOriginal: 'Licence originale',
      benefitAutoDelivery: 'Livraison automatique',
      benefitSupport: 'Support inclus',
      relatedProductsTitle: 'Produits Connexes',
      benefitGuarantee: 'Garantie de 7 jours',
      trustSecure: 'Achat sécurisé',
      trustVerified: 'Produit vérifié',
      trustClients: '+1000 clients',
      trustFastDelivery: 'Livraison immédiate',
      urgencyStock: ' Stock numérique limité – assurez le vôtre maintenant avant qu\'il ne soit épuisé!',
      ctaUrgency: '🔥 Ne manquez pas cette offre – le prix peut changer à tout moment',
      ctaPayment: 'Paiement sécurisé',
      ctaEmail: 'Livraison par e-mail',
      ctaGuarantee: '7 jours de garantie',
      affiliateTitle: 'Gagnez de l\'argent en recommandant ce produit.',
      affiliateSub: 'Devenez affilié.',
      affiliateBtn: 'Je veux m\'inscrire'
    }
  }
  return {
    home: 'Início',
    products: 'Produtos',
    loading: 'Carregando produto...',
    notFound: 'Produto não encontrado.',
    buy: 'Comprar',
    addToCartBtn: 'Adicionar ao carrinho',
    included: 'O que está incluído:',
    installmentsPrefix: 'em até 12x de',
    pixLabel: 'Pagamento à vista no PIX',
    digitalDelivery: 'Entrega digital — Disponível',
    freeRefund: 'Devolução grátis. Até 7 dias a partir do recebimento',
    guarantee: 'Compra garantida. Saia satisfeito ou devolvemos seu dinheiro',
    emailDelivery: 'Envio por e-mail após confirmação',
    tutorialCardTitle: 'Tutorial de Ativação',
    viewTutorial: 'Ver Tutorial',
    tutorialLoginRequired: 'Entre para acessar',
    detailedDescription: 'Descrição Detalhada',
    whyPriceTitle: 'Por que o preço é tão bom? Entenda.',
    whyPriceP1: 'Nossos preços são mais acessíveis porque trabalhamos com distribuição digital, sem custos de mídia física, logística ou intermediários.',
    whyPriceP2: 'Isso nos permite oferecer valores competitivos, mantendo suporte e envio imediato após confirmação.',
    ms365HowTitle: 'Microsoft 365 / Office 365 – como funciona',
    ms365Bullet1: '',
    ms365Bullet2: 'Entrega por conta fornecida (login e senha) após a confirmação do pagamento.',
    ms365Bullet3: 'O acesso é feito com a conta fornecida (não é ativação em uma conta Microsoft pessoal já existente).',
    ms365HelpPrefix: 'Dúvidas? Consulte',
    ms365HelpLink: 'Entrega digital',
    urgencyBadge: '🔥 Oferta por tempo limitado',
    buyNowBtn: '🛒 COMPRAR AGORA',
    microInstant: 'Entrega imediata',
    microActivation: 'Ativação em minutos',
    microSecure: 'Compra segura',
    benefitOriginal: 'Licença original',
    benefitAutoDelivery: 'Entrega automática',
    benefitSupport: 'Suporte incluso',
    relatedProductsTitle: 'Produtos Relacionados',
    benefitGuarantee: 'Garantia de 7 dias',
    trustSecure: 'Compra segura',
    trustVerified: 'Produto verificado',
    trustClients: '+1000 clientes',
    trustFastDelivery: 'Envio imediato',
    urgencyStock: ' Estoque digital limitado – garanta o seu agora antes que acabe!',
    ctaUrgency: '🔥 Não perca esta oferta – preço pode mudar a qualquer momento',
    ctaPayment: 'Pagamento seguro',
    ctaEmail: 'Entrega por e-mail',
    ctaGuarantee: '7 dias de garantia',
    affiliateTitle: 'Ganhe dinheiro recomendando este produto.',
    affiliateSub: 'Torne-se um afiliado.',
    affiliateBtn: 'Quero me cadastrar'
  }
})

const { addToCart } = useCart()

async function buyNow() {
  const p = safeProduct.value
  console.log('[buyNow] safeProduct:', p, 'slug:', slug, 'p.slug:', p?.slug)
  try {
    ecomAddToCart({
      item_id: p?.id || '',
      item_name: String(p?.name || p?.name || ''),
      price: Number(p?.price ?? 0),
      item_category: primaryCategoryLabel.value || 'Software'
    }, 'BRL')
  } catch {
    // ignore
  }

  // Adicionar ao carrinho
  addToCart({
    id: p?.id || '',
    name: String(p?.name || ''),
    slug: String(p?.slug || slug.value || ''),
    price: Number(p?.price ?? 0),
    image: String(p?.image || '')
  })

  const slugValue = String(p?.slug || slug.value || '')
  const checkoutPath = intl.currencyLower.value !== 'brl' ? '/checkout-intl' : '/checkout'
  console.log('[buyNow] Navigating to:', checkoutPath, 'with product:', slugValue, 'intl.currencyLower:', intl.currencyLower.value)
  await navigateTo({ path: checkoutPath, query: { product: slugValue } }, { replace: false })
}

function addToCartOnly() {
  const p = safeProduct.value
  addToCart({
    id: p?.id || '',
    name: String(p?.name || ''),
    slug: String(p?.slug || slug.value || ''),
    price: Number(p?.price ?? 0),
    image: String(p?.image || '')
  })
  
  try {
    ecomAddToCart({
      item_id: p?.id || '',
      item_name: String(p?.name || ''),
      price: Number(p?.price ?? 0),
      item_category: primaryCategoryLabel.value || 'Software'
    }, 'BRL')
  } catch {
    // ignore
  }
  
  navigateTo('/cart')
}
</script>

<style scoped>
/* Forçar fundo transparente em v-html com estilos inline - Tailwind prose-invert cuida das cores */
.prose :deep(p),
.prose :deep(h1),
.prose :deep(h2),
.prose :deep(h3),
.prose :deep(h4),
.prose :deep(h5),
.prose :deep(h6),
.prose :deep(li),
.prose :deep(ul),
.prose :deep(ol),
.prose :deep(span),
.prose :deep(div),
.prose :deep(strong),
.prose :deep(em),
.prose :deep(a),
.prose :deep(code),
.prose :deep(pre) {
  background-color: transparent !important;
  background: transparent !important;
  color: #cbd5e1 !important;
}
.prose :deep(table),
.prose :deep(td),
.prose :deep(th) {
  background-color: transparent !important;
  border-color: rgba(148,163,184,0.2) !important;
}
.seo-content-dark :deep(p),
.seo-content-dark :deep(h1),
.seo-content-dark :deep(h2),
.seo-content-dark :deep(h3),
.seo-content-dark :deep(h4),
.seo-content-dark :deep(h5),
.seo-content-dark :deep(h6),
.seo-content-dark :deep(li),
.seo-content-dark :deep(ul),
.seo-content-dark :deep(ol),
.seo-content-dark :deep(span),
.seo-content-dark :deep(div),
.seo-content-dark :deep(strong),
.seo-content-dark :deep(em),
.seo-content-dark :deep(a),
.seo-content-dark :deep(code),
.seo-content-dark :deep(pre) {
  background-color: transparent !important;
  background: transparent !important;
  color: #cbd5e1 !important;
}
</style>
